import { ErrorHandlerRegister } from '@/services/ErrorHandler'
import Vue from 'vue'

ErrorHandlerRegister(Vue)
